import { render, staticRenderFns } from "./TrialRatingLabel.vue?vue&type=template&id=657bad30&scoped=true"
import script from "./TrialRatingLabel.vue?vue&type=script&lang=js"
export * from "./TrialRatingLabel.vue?vue&type=script&lang=js"
import style0 from "./TrialRatingLabel.vue?vue&type=style&index=0&id=657bad30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657bad30",
  null
  
)

export default component.exports